module.exports = __webpack_public_path__ + "static/media/fast_forward.00ea8dce.svg";